export default {
  lessons: [],
  pagination: {
    current_page: 1,
    per_page: 15,
    total: 0,
  },
};
